import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { TruthSection } from './components/TruthSection';
import { ProductReveal } from './components/ProductReveal';
import { TransformSection } from './components/TransformSection';
import { CTASection } from './components/CTASection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyHeader } from './components/StickyHeader';
import { SocialProof } from './components/SocialProof';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="w-full bg-cream min-h-screen overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyHeader data-id="element-2" />
      <HeroSection data-id="element-3" />
      <StorySection data-id="element-4" />
      <TruthSection data-id="element-5" />
      <ProductReveal data-id="element-6" />
      <TransformSection data-id="element-7" />
      <CTASection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
      <SocialProof data-id="element-12" />
    </main>;
}